import { Component, Vue, Prop } from 'vue-property-decorator';
import { MiDialogOptions } from '../MiDialog/MiDialog';

@Component<MiElementPanelItemsWrap>({ })
export default class MiElementPanelItemsWrap extends Vue {
  @Prop({ default: false })
  protected hasForm!: boolean;

  @Prop({ default: 'mdi-content-save' })
  protected buttonIcon!: string;

  @Prop({ default: 'Save Changes' })
  protected buttonTitle!: string;

  protected isLoading = false;

  protected formValid = false;

  protected mounted(): void {
    this.$on('loadChange', this.handleLoadChange);
    this.$on('formValidChange', this.handleFormValidChange);
    this.$on('saveStatus', this.handleSaveStatus);
  }

  protected handleLoadChange(value: boolean): void {
    this.isLoading = value;
  }

  protected handleFormValidChange(value: boolean): void {
    this.formValid = value;
  }

  protected handleSaveStatus(value: boolean): void {
    if (value) {
      this.$store.dispatch('openDialog', this.saveSuccessDialogOptions);
      return;
    }
    this.$store.dispatch('openDialog', this.saveFailedDialogOptions);
  }

  protected handleSaveRequest(): void {
    if (this.canSave) {
      this.$emit('saveRequest');
    }
  }

  protected get canSave(): boolean {
    return this.formValid && ! this.isLoading;
  }

  protected get saveSuccessDialogOptions(): MiDialogOptions {
    return {
      text: 'Saved successfully',
      type: 'success',
      buttons: {
        confirm: {
          text: 'Close',
          action: () => {
            this.$store.dispatch('closeDialog');
          },
        },
      },
    };
  }

  protected get saveFailedDialogOptions(): MiDialogOptions {
    return {
      text: 'Saving failed',
      type: 'error',
      buttons: {
        confirm: {
          text: 'Close',
          action: () => {
            this.$store.dispatch('closeDialog');
          },
        },
      },
    };
  }
}
